export const PlayerState = {
    Buffering: 'Buffering',
    Ended: 'Ended',
    Idle: 'Idle',
    Playing: 'Playing',
    Ready: 'Ready',
};

export default PlayerState;
